module.exports = __webpack_public_path__ + "static/media/logo-pipedrive.538ea701.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-pipedrive.png
// module id = 1305
// module chunks = 17